<script>
    import { formattedDate } from "$/utils/date";

    import { ServiceConsts } from "$/services/ServiceConsts";
    import { TenantStore } from "$/stores/TenantStore";
    import { getEffectivePricingPlan } from "$/utils/Utils";

    import { redirect } from "@roxi/routify";
    import { AppStore } from "$/stores/AppStore";

    export let standalone;

    $: tenant = $TenantStore ? $TenantStore.active : null;
    $: pricingPlan = tenant ? tenant.pricingPlan : 0;
    $: effectivePricingPlan = tenant ? getEffectivePricingPlan(tenant) : 0;
    $: upgradeable = effectivePricingPlan === 0 || TenantStore.isExpired();
    $: manageable = effectivePricingPlan === 1 || pricingPlan === 2;

    function managePayment() {
        if (!upgradeable && !manageable) return;

        if (standalone) {
            $redirect("/payment");
            AppStore.closePanels();
        } else {
            window.open(
                `${ServiceConsts.DASHBOARD_URL}/#/${tenant.id}/payment`,
                "_blank",
            );
        }
    }
</script>

<a
    class="menu-item"
    href={"#"}
    on:click={managePayment}
    class:menu-item--pointer={upgradeable || manageable}
>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class="menu-item-icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
        />
    </svg>

    <span class="menu-item-title">
        {#if effectivePricingPlan === 0}
            Free
        {:else if effectivePricingPlan === 1}
            Personal Pro
        {:else if pricingPlan === 2}
            Team
        {/if}
    </span>

    <div class="spacer"></div>

    {#if effectivePricingPlan === 0}
        <span class="menu-item-button">
            Upgrade
            <svg
                class="menu-item-button__icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
                />
            </svg>
        </span>
    {:else if tenant?.lifetime}
        <span class="menu-item-button">
            Lifetime
            <svg
                class="menu-item-button__icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                />
            </svg>
        </span>
    {:else if $TenantStore && TenantStore.isExpired()}
        <span class="menu-item-button">
            Expired
            <svg
                class="menu-item-button__icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
                />
            </svg>
        </span>
    {:else if pricingPlan > 0}
        <span class="menu-item-button">
            {TenantStore.isExpiring() ? "Expires" : "Renews"}
            {formattedDate($TenantStore?.active?.expirationDate)}
        </span>
    {/if}
</a>

{#if manageable}
    <a class="menu-item menu-item--pointer" href={"#"} on:click={managePayment}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="menu-item-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971z"
            />
        </svg>

        <span class="menu-item-title"> Manage payment plan </span>

        <div class="spacer"></div>

        <span class="menu-item-button">
            <svg
                class="menu-item-button__icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
            </svg>
        </span>
    </a>
{/if}

<style>
    @import "../main.css";

    .menu-item-icon {
        @apply reset ml-1 h-4 w-4 !important;
    }

    .menu-item-title {
        @apply reset ml-2 text-sm !important;
    }

    .menu-item {
        @apply reset flex select-none flex-row items-center border-b border-solid border-gray-200 bg-white px-4 py-2 text-gray-800 no-underline hover:bg-gray-100 !important;
    }

    .menu-item--pointer {
        @apply cursor-pointer !important;
    }

    .duration {
        @apply reset text-xs !important;
    }

    .menu-item-button {
        @apply reset flex flex-row gap-1 text-xs !important;
    }
    .menu-item-button__icon {
        @apply reset h-4 w-4 !important;
    }

    .spacer {
        @apply reset grow !important;
    }
</style>
